import React, { FC, useState } from "react";

import { Container, Paper, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import DeleteActionDialog, { Entry } from "../../components/DeleteActionDialog";
import Header from "../../components/Header";
import Page from "../../components/Page";
import { useDialog } from "../../hooks/use-dialog";
import { useSelector } from "../../store";
import {
  useListUsersInOrganizationQuery,
  useRemoveUserFromOrganizationMutation,
} from "../../store/pomeriumApi";
import AddApiUser from "./AddApiUser";
import RefreshToken, { RefreshTokenParams } from "./RefreshToken";

const ApiUsers: FC = () => {
  const { organizationId } = useSelector((state) => state.current);
  const [showDelete, setShowDelete] = useState(false);
  const [selected, setSelected] = useState<Entry[]>([]);
  const refreshDialog = useDialog<RefreshTokenParams>();
  const refreshToken = (userId: string) => {
    refreshDialog.handleOpen({ orgId: organizationId, userId });
  };

  const [deleteUser] = useRemoveUserFromOrganizationMutation();
  const { data: users } = useListUsersInOrganizationQuery(
    { organizationId },
    {
      skip: !organizationId,
    },
  );

  function handleCloseDelete() {
    setShowDelete(false);
  }

  async function handleDelete() {
    await Promise.all(
      selected.map((user) => deleteUser({ organizationId, userId: user.id })),
    );
  }

  const clickRemove = (id: string, name: string) => {
    setSelected([{ id, name }]);
    setShowDelete(true);
  };

  const apiUsers = users?.filter((u) => u.type === "user_type_api_access");

  return (
    <Page title="API Users">
      <Header title="API Users" breadcrumbs={false} actions={<AddApiUser />} />
      <DeleteActionDialog
        buttonText="Remove"
        name="API User"
        open={showDelete}
        entries={selected}
        onClose={handleCloseDelete}
        onDelete={handleDelete}
      />
      <RefreshToken dialog={refreshDialog} />
      <Container component={Paper} maxWidth={false} disableGutters={true}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableBody>
          <TableBody>
            {!apiUsers?.length && (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  Currently No API Users
                </TableCell>
              </TableRow>
            )}
            {apiUsers?.map((user) => (
              <TableRow key={"apiUser_" + user.id}>
                <TableCell>{user.displayName}</TableCell>
                <TableCell>
                  <Stack direction="row" spacing={2}>
                    <Button
                      key={"remove_" + user.id}
                      color="error"
                      onClick={() =>
                        clickRemove(user.id, user.displayName || "")
                      }
                    >
                      Remove
                    </Button>
                    <Button
                      key={"refresh_" + user.id}
                      onClick={() => refreshToken(user.id)}
                    >
                      Refresh Token
                    </Button>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Container>
    </Page>
  );
};
export default ApiUsers;
